module.exports = __webpack_public_path__ + "static/media/ebills-main.c9a49514.svg";